export const dumpCurrenciesAllRates = currencyRates => {
  if (!currencyRates) {
    return null;
  }

  const rates = {
    midbank: {},
    interbank: {},
    auction: {},
    nbu: {},
  };

  Object.keys(currencyRates).forEach(item => {
    if (item === 'UAH') {
      return false;
    }

    let sort = null;
    if (item === 'EUR') {
      sort = 2;
    } else if (item === 'PLN') {
      sort = 3;
    } else if (item === 'GBP') {
      sort = 4;
    } else if (item === 'CHF') {
      sort = 5;
    } else sort = 1;

    // eslint-disable-next-line consistent-return
    return Object.keys(rates).forEach(type => {
      const rate = currencyRates[item][type];

      const trendAsk = rate.sell.trend === '-' ? 0 : rate.sell.trend;
      const trendBid = rate.buy.trend === '-' ? 0 : rate.buy.trend;

      // eslint-disable-next-line no-nested-ternary
      const ask = rate.sell.val
        ? type === 'auction'
          ? Number(rate.sell.val).toFixed(2)
          : rate.sell.val
        : '-';

      // eslint-disable-next-line no-nested-ternary
      const bid = rate.buy.val
        ? type === 'auction'
          ? Number(rate.buy.val).toFixed(2)
          : rate.buy.val
        : '-';

      const formattedRate = {
        date: rate.buy.timestamp,
        ask,
        bid,
        trendAsk,
        trendBid,
        currency: item.toLowerCase(),
        type,
        sort,
        ...(type === 'midbank'
          ? {
              diffNBU: currencyRates[item].nbu.sell.trend,
              nbu: currencyRates[item].nbu.sell.val,
            }
          : {}),
      };

      rates[type][item] = formattedRate;
    });
  });
  return rates;
};

export default dumpCurrenciesAllRates;
